import {
    FunctionName,
    MemberApiEndpoints,
    SLResponse
} from "shared/functions/common";

import Config from "../../Config/Config";
import { NetworkService } from "../../Network/NetworkService";
import FirebaseAuthService from "../auth/FirebaseAuthService";
import { IAnalyticsFuncResponse } from "shared/functions/admin/analytics";
import QueryUtils from "src/services/utils/QueryUtils";
import {IDeferPaymentRequest} from "shared/functions/membersApi/types/IUserAccountFuncResponse";
import {ILoanPlanChangeRequest} from "../../../../../shared/src/functions/membersApi/types/IPlanRequests";

export default class FirebaseMyAccountService {
    public static myAccountBasePath(endPoint: MemberApiEndpoints) {
        const baseUrl = Config.firebaseFunctionsUrl();
        return `${baseUrl}/${FunctionName.membersApi}/${endPoint}`;
    }

    public static async authenticatedGet<T>(url: string) {
        const token = await FirebaseAuthService.getAuthToken();
        return NetworkService.authenticatedGet<SLResponse<T>>(url, token as string);
    }

    public static async authenticatedPost(url: string, body: any) {
        const token = await FirebaseAuthService.getAuthToken();
        return NetworkService.authenticatedPost<SLResponse>(url, body, token as string);
    }

    
    public static getOtherUserAccount(uid : string) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.account
        );
        const finalUrl = `${url}${QueryUtils.stringify({uid})}`
        return FirebaseMyAccountService.authenticatedGet<
            IAnalyticsFuncResponse
            >(finalUrl);
    }

    public static getApplications() {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.account
        );
        return FirebaseMyAccountService.authenticatedGet<
            IAnalyticsFuncResponse
            >(url);
    }

    public static addPlan(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.addPlan
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static updateLoanPlan(params: ILoanPlanChangeRequest) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.manageLoan
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static upgradePlan(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.upgradePlan
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static cancelPlan(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.cancelPlan
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static deferPayment(params: IDeferPaymentRequest) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.deferPayment
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static replacePaymentMethod(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.replacePaymentMethod
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static payMemberOutstandingBalance(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.payMemberOutstandingBalance
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static getMemberOutstandingBalance() {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.getMemberOutstandingBalance
        );
        return FirebaseMyAccountService.authenticatedPost(url, {});
    }

    public static markNotificationAsSeen(params: any) {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.markNotification
        );
        return FirebaseMyAccountService.authenticatedPost(url, params);
    }

    public static markOnBoardingAsSeen() {
        const url = FirebaseMyAccountService.myAccountBasePath(
            MemberApiEndpoints.markOnBoarding
        );
        return FirebaseMyAccountService.authenticatedPost(url, {});
    }
}



// WEBPACK FOOTER //
// ./src/services/firebase/functions/FirebaseMyAccountFunctionsService.ts